import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { finalize } from 'rxjs/operators';

@Injectable()
export class LoadingBarSkipInterceptor implements HttpInterceptor {
  constructor(private loadingBar: LoadingBarService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if the request has the header to skip loading bar
    const shouldSkip = req.headers.has('X-Loading-Bar') && req.headers.get('X-Loading-Bar') === 'false';
    
    if (shouldSkip) {
      // Complete loading bar immediately to prevent it from showing
      // This will hide it if the LoadingBarHttpClientModule interceptor started it
      this.loadingBar.complete();
      
      return next.handle(req).pipe(
        finalize(() => {
          // Ensure loading bar stays hidden when request completes
          this.loadingBar.complete();
        })
      );
    }
    
    // For all other requests, let the default loading bar behavior work
    return next.handle(req);
  }
}

